import {ExperimentsBag} from '@wix/yoshi-flow-editor';

export const SPECS = {
  PRODUCT_PAGE_BLOCKS_MS4: 'specs.stores.ProductPageBlockMS4',
  PRODUCT_PAGE_BLOCKS_MS3: 'specs.stores.ProductPageBlockMS3',
  UseNewCheckoutInVisitorShippingAndDigitalFlow: 'specs.stores.UseNewCheckoutInVisitorShippingAndDigitalFlow',
  RenderOnDeviceViewChanged: 'specs.stores.ProductPageBlocksRenderOnDeviceViewChanged',
  NonControlledDropdown: 'specs.stores.ProductPageBlocksNonControlledDropdown',
  ProductPageBlocksNoNavigationDuringInstallation: 'specs.stores.ProductPageBlocksNoNavigationDuringInstallation',
  UseMiniCartStylesInSideCart: 'specs.stores.UseMiniCartStylesInSideCart',
  SendSubcategoriesSeoDataSF: 'specs.stores.SendSubcategoriesSeoDataSF',
  ShouldCheckDiscountInVariantLevel: 'specs.stores.shouldCheckDiscountVariantLevelPPOB',
  EnableRicoForSeoTags: 'specs.stores.ProductPageBlocksEnableRicoForSeoTags',
  UseStoresCatalogV3PPOB: 'specs.stores.UseStoresCatalogV3PPOB',
  EnableStoresViewerScriptInViewer: 'specs.stores.EnableStoresViewerScriptInViewer',
  PreloadCarts: 'specs.stores.ProductPageBlocksPreloadCarts',
  EnablePanoramaIntegration: 'specs.stores.ProductPageBlocksEnablePanoramaIntegration',
  ProductPageSlotsAddMoreProps: 'specs.stores.ProductPageSlotsAddMoreProps',
  ProductPageBlocksFixAddToCartOnSecondaryLang: 'specs.stores.ProductPageBlocksFixAddToCartOnSecondaryLang',
  PPOBCustomTextDebounce: 'specs.stores.PPOBCustomTextDebounce',
  UpdateBreadcrumbsAfterHydration: 'specs.stores.ProductPageBlocksUpdateBreadcrumbsAfterHydration',
  PPOBCreateCheckoutFromPublicApi: 'specs.stores.PPOBCreateCheckoutFromPublicApi',
  ProductPageSsrInvalidationTags: 'specs.stores.ProductPageSsrInvalidationTags',
  AddToCartWithSubscription: 'specs.stores.ProductPageBlocksAddToCartWithSubscription',
  AddToCartWithTrackData: 'specs.stores.ProductPageBlocksAddToCartWithTrackData',
  OptionButtonsUoU: 'specs.stores.ProductPageBlocksOptionButtonsUoU',
  OptionButtonsPanels: 'specs.stores.ProductPageBlocksOptionButtonsPanels',
  RemoveDeprecatedAppId: 'specs.stores.ProductPageBlocksRemoveDeprecatedAppId',
} as const;

const openedExperimentsForTests: string[] = [
  SPECS.PRODUCT_PAGE_BLOCKS_MS3,
  SPECS.NonControlledDropdown,
  SPECS.UseMiniCartStylesInSideCart,
  SPECS.SendSubcategoriesSeoDataSF,
  SPECS.ShouldCheckDiscountInVariantLevel,
  SPECS.EnableRicoForSeoTags,
  SPECS.UseStoresCatalogV3PPOB,
  SPECS.PreloadCarts,
  SPECS.EnablePanoramaIntegration,
  SPECS.ProductPageSlotsAddMoreProps,
  SPECS.PPOBCustomTextDebounce,
  SPECS.UpdateBreadcrumbsAfterHydration,
  SPECS.PPOBCreateCheckoutFromPublicApi,
  SPECS.ProductPageSsrInvalidationTags,
  SPECS.AddToCartWithSubscription,
  SPECS.AddToCartWithTrackData,
  SPECS.OptionButtonsUoU,
  SPECS.OptionButtonsPanels,
  SPECS.RemoveDeprecatedAppId,
];

const openedExperimentsForSled = [
  'specs.thunderbolt.new_responsive_layout_loggedIn',
  SPECS.NonControlledDropdown,
  SPECS.UseMiniCartStylesInSideCart,
  SPECS.SendSubcategoriesSeoDataSF,
  SPECS.ShouldCheckDiscountInVariantLevel,
  SPECS.EnableRicoForSeoTags,
  SPECS.EnableStoresViewerScriptInViewer,
  SPECS.PreloadCarts,
  SPECS.EnablePanoramaIntegration,
  SPECS.ProductPageSlotsAddMoreProps,
  SPECS.PPOBCustomTextDebounce,
  SPECS.UpdateBreadcrumbsAfterHydration,
  SPECS.PPOBCreateCheckoutFromPublicApi,
  SPECS.ProductPageSsrInvalidationTags,
  SPECS.AddToCartWithSubscription,
  SPECS.AddToCartWithTrackData,
  SPECS.OptionButtonsUoU,
  SPECS.RemoveDeprecatedAppId,
];

export const getOpenedExperimentsForTests = (): ExperimentsBag => {
  return openedExperimentsForTests.reduce((prv: any, cur: any) => {
    prv[cur] = 'true';
    return prv;
  }, {});
};

export const getOpenedExperimentsForSled = () => {
  return openedExperimentsForSled.reduce((obj, ex) => {
    obj[ex] = true;
    return obj;
  }, {});
};

export const mapExperimentsToStrings = (experiments: ExperimentsBag) => {
  return Object.entries(experiments).reduce((acc, [key, value]) => {
    acc[key] = value.toString();
    return acc;
  }, {} as Record<string, string>);
};

export const mapExperimentsToBooleans = (experiments: ExperimentsBag) => {
  return Object.entries(experiments).reduce((acc, [key, value]) => {
    if (value === true || value === false) {
      acc[key] = value;
      return acc;
    } else if (value === 'true' || value === 'false') {
      acc[key] = value === 'true' ? true : false;
      return acc;
    }
    return acc;
  }, {} as Record<string, boolean>);
};
